import { moduleSelectLinkModuleOptionWithModuleFragment } from '#fragments/modules.js';
import {
  moduleSelectLinkDatabaseObjectOptionWithObjectFragment,
  moduleSelectLinkDataFragment,
  moduleSelectLinkFragment,
  moduleSelectLinkRuledPriceOptionWithPriceFragment,
  moduleSelectLinkSubcontractingOptionWithSubcontractingFragment,
} from '#fragments/moduleSelectLinks';
import { gql } from '@apollo/client/core';

export const MODULE_SELECT_LINK_BY_ID = gql`
  ${moduleSelectLinkFragment}
  query module_select_link_by_id($id: bigint!) {
    module_select_links_by_pk(id: $id) {
      ...ModuleSelectLinkFragment
    }
  }
`;

export const MODULE_SELECT_LINK_CREATE = gql`
  ${moduleSelectLinkDataFragment}
  mutation CreateModuleSelectLink($object: module_select_links_insert_input!) {
    insert_module_select_links_one(object: $object) {
      ...ModuleSelectLinkDataFragment
    }
  }
`;

export const MODULE_SELECT_LINK_UPDATE = gql`
  ${moduleSelectLinkDataFragment}
  mutation UpdateModuleSelectLink($object: module_select_links_set_input!, $id: bigint!) {
    update_module_select_links_by_pk(pk_columns: { id: $id }, _set: $object) {
      ...ModuleSelectLinkDataFragment
    }
  }
`;

export const MODULE_SELECT_LINK_DELETE = gql`
  mutation DeleteModuleSelectLink($id: bigint!, $versionId: Int!) {
    update_module_select_links_by_pk(pk_columns: { id: $id }, _set: { is_deleted_at_version: $versionId }) {
      id
    }
  }
`;

export const MODULE_SELECT_LINK_OPTION_OBJECT = gql`
  ${moduleSelectLinkModuleOptionWithModuleFragment}
  ${moduleSelectLinkRuledPriceOptionWithPriceFragment}
  ${moduleSelectLinkSubcontractingOptionWithSubcontractingFragment}
  ${moduleSelectLinkDatabaseObjectOptionWithObjectFragment}
  query ModuleSelectLinkOptionObject($id: bigint!) {
    module_select_links_by_pk(id: $id) {
      module_select_link_module_options {
        ...ModuleSelectLinkModuleOptionWithModuleFragment
      }
      module_select_link_database_objects_options {
        ...ModuleSelectLinkDatabaseObjectOptionWithObjectFragment
      }
      module_select_link_ruled_price_options {
        ...ModuleSelectLinkRuledPriceOptionWithPriceFragment
      }
      module_select_link_subcontracting_options {
        ...ModuleSelectLinkSubcontractingOptionWithSubcontractingFragment
        subcontracting {
          ...SubcontractingFragment
          subcontracting_version(where: { is_latest: { _eq: true } }) {
            ...SubcontractingVersionFragment
          }
        }
      }
    }
  }
`;

export const MODULE_SELECT_LINKS_OPTION_OBJECT = gql`
${moduleSelectLinkModuleOptionWithModuleFragment}
${moduleSelectLinkRuledPriceOptionWithPriceFragment}
${moduleSelectLinkSubcontractingOptionWithSubcontractingFragment}
${moduleSelectLinkDatabaseObjectOptionWithObjectFragment}
query ModuleSelectLinkOptionObject($ids: [bigint!]!) {
  module_select_links(where: { id: { _in: $ids } }) {
    id
    module_select_link_module_options {
      ...ModuleSelectLinkModuleOptionWithModuleFragment
    }
    module_select_link_database_objects_options {
      ...ModuleSelectLinkDatabaseObjectOptionWithObjectFragment
    }
    module_select_link_ruled_price_options {
      ...ModuleSelectLinkRuledPriceOptionWithPriceFragment
    }
    module_select_link_subcontracting_options {
      ...ModuleSelectLinkSubcontractingOptionWithSubcontractingFragment
      subcontracting {
        ...SubcontractingFragment
        subcontracting_version(where: { is_latest: { _eq: true } }) {
          ...SubcontractingVersionFragment
        }
      }
    }
  }
}
`;

export const MODULE_SELECT_LINK_MODULE_OPTION_CREATE = gql`
  ${moduleSelectLinkModuleOptionWithModuleFragment}
  mutation CreateModuleSelectLinkModuleOption($object: module_select_link_module_options_insert_input!) {
    insert_module_select_link_module_options_one(object: $object) {
      ...ModuleSelectLinkModuleOptionWithModuleFragment
    }
  }
`;

export const MODULE_SELECT_LINK_MODULE_OPTION_UPDATE = gql`
  ${moduleSelectLinkModuleOptionWithModuleFragment}
  mutation UpdateModuleSelectLinkModuleOption(
    $id: bigint!,
    $object: module_select_link_module_options_set_input!
  ) {
    update_module_select_link_module_options_by_pk(
      pk_columns: { id: $id },
      _set: $object
    ) {
      ...ModuleSelectLinkModuleOptionWithModuleFragment
    }
  }
`;

export const MODULE_SELECT_LINK_MODULE_OPTION_UPDATE_BULK = gql`
  mutation UpdateModuleSelectLinkModuleOptionBulk($updates: [module_select_link_module_options_updates!]!) {
    update_module_select_link_module_options_many(
      updates: $updates
    ) {
      affected_rows
    }
  }
`;

export const MODULE_SELECT_LINK_MODULE_OPTION_DELETE = gql`
  mutation DeleteModuleSelectLinkModuleOption($id: bigint!) {
    delete_module_select_link_module_options_by_pk(
      id: $id
    ) {
      module_select_link_id
      module_id
    }
  }
`;

// Database object options queries and mutations
export const MODULE_SELECT_LINK_DATABASE_OBJECT_OPTIONS = gql`
  ${moduleSelectLinkDatabaseObjectOptionWithObjectFragment}
  query module_select_link_database_object_options($where: module_select_link_database_objects_options_bool_exp) {
    module_select_link_database_objects_options(where: $where) {
      ...ModuleSelectLinkDatabaseObjectOptionWithObjectFragment
    }
  }
`;

export const MODULE_SELECT_LINK_DATABASE_OBJECT_OPTION_CREATE = gql`
  ${moduleSelectLinkDatabaseObjectOptionWithObjectFragment}
  mutation CreateModuleSelectLinkDatabaseObjectOption($object: module_select_link_database_objects_options_insert_input!) {
    insert_module_select_link_database_objects_options_one(object: $object) {
      ...ModuleSelectLinkDatabaseObjectOptionWithObjectFragment
    }
  }
`;

export const MODULE_SELECT_LINK_DATABASE_OBJECT_OPTION_UPDATE = gql`
  ${moduleSelectLinkDatabaseObjectOptionWithObjectFragment}
  mutation UpdateModuleSelectLinkDatabaseObjectOption(
    $id: bigint!,
    $object: module_select_link_database_objects_options_set_input!
  ) {
    update_module_select_link_database_objects_options_by_pk(
      pk_columns: { id: $id },
      _set: $object
    ) {
      ...ModuleSelectLinkDatabaseObjectOptionWithObjectFragment
    }
  }
`;

export const MODULE_SELECT_LINK_DATABASE_OBJECT_OPTION_UPDATE_BULK = gql`
  ${moduleSelectLinkDatabaseObjectOptionWithObjectFragment}
  mutation UpdateModuleSelectLinkDatabaseObjectOptionBulk($updates: [module_select_link_database_objects_options_updates!]!) {
    update_module_select_link_database_objects_options_many(
      updates: $updates
    ) {
      affected_rows
    }
  }
`;

export const MODULE_SELECT_LINK_DATABASE_OBJECT_OPTION_DELETE = gql`
  mutation DeleteModuleSelectLinkDatabaseObjectOption($id: bigint!) {
    delete_module_select_link_database_objects_options_by_pk(
      id: $id
    ) {
      module_select_link_id
      database_object_id
    }
  }
`;

// Ruled price options queries and mutations
export const MODULE_SELECT_LINK_RULED_PRICE_OPTIONS = gql`
  ${moduleSelectLinkRuledPriceOptionWithPriceFragment}
  query module_select_link_ruled_price_options($where: module_select_link_ruled_price_options_bool_exp) {
    module_select_link_ruled_price_options(where: $where) {
      ...ModuleSelectLinkRuledPriceOptionWithPriceFragment
    }
  }
`;

export const MODULE_SELECT_LINK_RULED_PRICE_OPTION_CREATE = gql`
  ${moduleSelectLinkRuledPriceOptionWithPriceFragment}
  mutation CreateModuleSelectLinkRuledPriceOption($object: module_select_link_ruled_price_options_insert_input!) {
    insert_module_select_link_ruled_price_options_one(object: $object) {
      ...ModuleSelectLinkRuledPriceOptionWithPriceFragment
    }
  }
`;

export const MODULE_SELECT_LINK_RULED_PRICE_OPTION_UPDATE = gql`
  ${moduleSelectLinkRuledPriceOptionWithPriceFragment}
  mutation UpdateModuleSelectLinkRuledPriceOption(
    $id: bigint!,
    $object: module_select_link_ruled_price_options_set_input!
  ) {
    update_module_select_link_ruled_price_options_by_pk(
      pk_columns: { id: $id },
      _set: $object
    ) {
      ...ModuleSelectLinkRuledPriceOptionWithPriceFragment
    }
  }
`;

export const MODULE_SELECT_LINK_RULED_PRICE_OPTION_UPDATE_BULK = gql`
  ${moduleSelectLinkRuledPriceOptionWithPriceFragment}
  mutation UpdateModuleSelectLinkRuledPriceOptionBulk($updates: [module_select_link_ruled_price_options_updates!]!) {
    update_module_select_link_ruled_price_options_many(
      updates: $updates
    ) {
      affected_rows
    }
  }
`;

export const MODULE_SELECT_LINK_RULED_PRICE_OPTION_DELETE = gql`
  mutation DeleteModuleSelectLinkRuledPriceOption($id: bigint!) {
    delete_module_select_link_ruled_price_options_by_pk(
      id: $id
    ) {
      module_select_link_id
      ruled_price_id
    }
  }
`;

// Subcontracting options queries and mutations
export const MODULE_SELECT_LINK_SUBCONTRACTING_OPTIONS = gql`
  ${moduleSelectLinkSubcontractingOptionWithSubcontractingFragment}
  query module_select_link_subcontracting_options($where: module_select_link_subcontracting_options_bool_exp) {
    module_select_link_subcontracting_options(where: $where) {
      ...ModuleSelectLinkSubcontractingOptionWithSubcontractingFragment
    }
  }
`;

export const MODULE_SELECT_LINK_SUBCONTRACTING_OPTION_CREATE = gql`
  ${moduleSelectLinkSubcontractingOptionWithSubcontractingFragment}
  mutation CreateModuleSelectLinkSubcontractingOption($object: module_select_link_subcontracting_options_insert_input!) {
    insert_module_select_link_subcontracting_options_one(object: $object) {
      ...ModuleSelectLinkSubcontractingOptionWithSubcontractingFragment
    }
  }
`;

export const MODULE_SELECT_LINK_SUBCONTRACTING_OPTION_UPDATE = gql`
  ${moduleSelectLinkSubcontractingOptionWithSubcontractingFragment}
  mutation UpdateModuleSelectLinkSubcontractingOption(
    $id: bigint!,
    $object: module_select_link_subcontracting_options_set_input!
  ) {
    update_module_select_link_subcontracting_options_by_pk(
      pk_columns: { id: $id },
      _set: $object
    ) {
      ...ModuleSelectLinkSubcontractingOptionWithSubcontractingFragment
    }
  }
`;

export const MODULE_SELECT_LINK_SUBCONTRACTING_OPTION_UPDATE_BULK = gql`
  ${moduleSelectLinkSubcontractingOptionWithSubcontractingFragment}
  mutation UpdateModuleSelectLinkSubcontractingOptionBulk($updates: [module_select_link_subcontracting_options_updates!]!) {
    update_module_select_link_subcontracting_options_many(
      updates: $updates
    ) {
      affected_rows
    }
  }
`;

export const MODULE_SELECT_LINK_SUBCONTRACTING_OPTION_DELETE = gql`
  mutation DeleteModuleSelectLinkSubcontractingOption($id: bigint!) {
    delete_module_select_link_subcontracting_options_by_pk(
      id: $id
    ) {
      module_select_link_id
      subcontracting_id
    }
  }
`;
